function shuffleNotFoundRecommendations() {
  const section = document.querySelector('main[data-template="404"] [data-testid="product-list"]');
  if (!section) return;

  const items = [...section.querySelectorAll('.resource-list__item')];
  if (items.length <= 4) return;

  const selected = [...items].sort(() => Math.random() - 0.5).slice(0, 4);
  selected.forEach((item) => item.classList.add('ln-404-pick'));
  section.setAttribute('data-ln-shuffled', '');
}

function setupCollectionTabs() {
  const tabs = document.querySelector('[data-ln-collection-tabs]');
  if (!tabs) return;

  const params = new URLSearchParams(window.location.search);
  const requestedView = params.get('ln_view');

  if (requestedView) {
    tabs.querySelectorAll('a').forEach((tab) => {
      const isActive = tab.dataset.lnTab === requestedView;
      tab.classList.toggle('is-active', isActive);
      if (isActive) tab.setAttribute('aria-current', 'page');
      else tab.removeAttribute('aria-current');
    });
  }

  if (params.get('ln_fallback') !== '1') return;

  const products = [...document.querySelectorAll('.product-grid__item')];
  if (products.length <= 12) return;

  const visibleProducts = requestedView === 'featured'
    ? [...products].sort(() => Math.random() - 0.5).slice(0, 12)
    : products.slice(0, 12);

  const visibleSet = new Set(visibleProducts);
  products.forEach((product) => {
    product.hidden = !visibleSet.has(product);
  });
}

function setupBuyNow() {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-la-noire-buy-now]');
    if (!button || button.disabled) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Unable to add this item.');
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.alert(error.message);
    }
  });
}

function setupRandomRecommendations() {
  const recommendations = document.querySelector('[data-testid="product-recommendations-section"]');
  if (!recommendations) return;

  const showRandomFour = () => {
    const items = [...recommendations.querySelectorAll('.resource-list__item')];
    if (items.length < 4) return;

    const selected = [...items].sort(() => Math.random() - 0.5).slice(0, 4);
    const selectedSet = new Set(selected);
    items.forEach((item) => {
      item.hidden = !selectedSet.has(item);
    });
  };

  showRandomFour();
  const observer = new MutationObserver(showRandomFour);
  observer.observe(recommendations, { childList: true, subtree: true });
}

function initializeLaNoire() {
  shuffleNotFoundRecommendations();
  setupCollectionTabs();
  setupBuyNow();
  setupRandomRecommendations();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLaNoire, { once: true });
} else {
  initializeLaNoire();
}
